module.exports = __webpack_public_path__ + "img/img-hoteles.e3ac01da.webp";